export const localStorageArrayHandler = (flag, key, permissionList) => {
  if (flag === 'stringify') {
    const permissions = JSON.stringify(permissionList);
    window.localStorage.setItem(key, permissions);
  } else if (flag === 'parse') {
    const permissions = JSON.parse(window.localStorage.getItem(key));
    return permissions;
  }
};
